

















import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseChip",
  props: { small: { type: Boolean, default: false } },
});
